<mat-card [ngClass]="cardClass">
  <ng-content></ng-content>
</mat-card>
